<template>
  <div class="part-wrapper part-wrapper-screen">
    <p class="title-name">{{ name }}</p>
    <p class="title-desc">{{ desc }}</p>
    <div class="list">
      <Button
        type="icon"
        class="list-item"
        v-for="(item, index) in itemList"
        :key="index"
        @click="$emit('click', item)"
      >
        <span
          class="star-icon-score"
        >
          {{ item.cmSeq }}
        </span>
        <i
          :class="[
            `star-icon-${ item.star }`
          ]"
        />
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '../Button.vue';

export default {
  name: 'part',

  components: {
    Button,
  },

  props: {
    name: String,
    desc: String,
    itemList: Array,
  },
};
</script>

<style lang='less' scoped>
.part-wrapper {
  padding: 18px 30px 0px;
  margin: 0 auto;

  .title-name {
    width: 100%;
    line-height: 33px;
    font-size: 22px;
  }

  .title-desc {
    width: 100%;
    line-height: 20px;
    font-size: 16px;
    margin-top: 8px;
  }

  .list {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    margin: 30px 0 20px;

    &-item {
      width: 94px;
      height: 94px;
      margin: 0 10px 20px;
    }
  }
}
</style>
